module.exports = __webpack_public_path__ + "static/sistema-62062847c54bce92908fa52e0a078a46.jpg";